import React,
{
    useState,
    useEffect,
    useContext,
    useRef
}
from "react";

import
{
    store
}
from "../../../context/store";

import
{
    useHistory
}
from "react-router-dom";

import LeftMenu
    from "../../../components/LeftMenu";

import AssetDetailsDrawer
    from "./components/AssetDetailsDrawer";

import useBuildingBook
    from "./hooks/useBuildingBook";

export default function GiraffeAdmin()
{
    const globalState =
        useContext(store);

    const history =
        useHistory();

    const viewerRef =
        useRef(null);

		const [assetOpen, setAssetOpen] =
		    useState(false);

		const [assetCode, setAssetCode] =
		    useState(null);

    const
    {
        hotspot,
        assets,
		selectedAsset,
        selectedAssetId,
        setSelectedAssetId
    }
    =
    useBuildingBook();

    useEffect(
        function()
        {
            if(viewerRef)
            {
                window.addEventListener(
                    "message",

                    function(event)
                    {
                        const tourFrame =
                            viewerRef.current;

                        if(
                            !tourFrame
                        )
                        {
                            return;
                        }

                        if(
                            event.source !==
                            tourFrame.contentWindow
                        )
                        {
                            return;
                        }

                        if(
                            event.data?.type !==
                            "g360:info-hotspot-click"
                        )
                        {
                            return;
                        }

                        const
                        {
                            hotspotId
                        }
                        =
                        event.data;

                        handleHotspotClick(
                            hotspotId
                        );
                    }
                );
            }
        },
        []
    );
	
	
	const
	[
	    displayAssetDetails,

	    setDisplayAssetDetails
	]
	=
	useState(false);

	const handleHotspotClick =
	    function(hotspotId)
	    {
	        setAssetCode(
	            hotspotId
	        );

	        setAssetOpen(
	            true
	        );
	    };

    const pageContainer =
    {
        position: "relative",

        minHeight: "100vh",

        overflowX: "hidden",

        overflowY: "auto"
    };

    const pageBackground =
    {
        position: "fixed",

        top: 0,

        left: 0,

        width: "100vw",

        height: "100vh",

        backgroundColor: "white",

        zIndex: 0,

        pointerEvents: "none"
    };

    const thisContainer =
    {
        display: "flex",

        flexDirection: "column",

        width: "100%",

        marginTop: "50px",

        minHeight: "100vh",

        position: "relative",

        zIndex: 1
    };

    const mainContent =
    {
        display: "flex",

        position: "fixed",

        left: "60px",

        top: "0px",

        right: "0px",

        bottom: "0px"
    };

    const thisFrame =
    {
        width: "100%",

        height: "100%"
    };

	const assetListPopup =
	{
	    position: "absolute",

	    top: "90px",

	    right: "30px",

	    zIndex: 5000
	};

	const assetDetailsPopup =
	{
	    position: "absolute",

	    top: "90px",

	    right: "380px",

	    zIndex: 4999
	};

    return (

        <div style={pageContainer}>

            <div style={pageBackground} />

            <div style={thisContainer}>

                <LeftMenu />

                <div style={mainContent}>

                    <iframe
                        ref={viewerRef}
                        style={thisFrame}
                        src="https://tour.giraffe360.com/49c74ed43a75417c96cf6a2684fac357"
                    />

					<AssetDetailsDrawer

					    assetOpen={assetOpen}

					    assetCode={assetCode}

					    setAssetOpen={setAssetOpen}

					    assets={assets}

					    selectedAssetId={selectedAssetId}

					    setSelectedAssetId={setSelectedAssetId}

					    selectedAsset={selectedAsset}


					/>

                </div>

            </div>
			
        </div>

    );
}